import type { AccountPlanDto, PlanDto } from '@gr/core/accounts/plans/dto';
import { PlanLimit, type PlanLimitValue } from '@gr/core/accounts/plans/limits';

// PLAN-UC-4, PLAN-UC-5: израсходованное по лимитам — доли, «исчерпан», единицы; без React.

export enum LimitUnit {
  Count = 'count',
  Megabytes = 'mb',
  Gigabytes = 'gb',
}

export const LIMIT_UNITS: Readonly<Record<PlanLimit, LimitUnit>> = {
  [PlanLimit.Blogs]: LimitUnit.Count,
  [PlanLimit.Editors]: LimitUnit.Count,
  [PlanLimit.StorageMb]: LimitUnit.Megabytes,
  [PlanLimit.MediaPerDay]: LimitUnit.Count,
  [PlanLimit.PostsPerDay]: LimitUnit.Count,
  [PlanLimit.TrafficGbPerMonth]: LimitUnit.Gigabytes,
};

const MB = 1024 * 1024;

/** Объём в байтах для formatFileSize; число штук — null. */
export function amountBytes(limit: PlanLimit, value: number): number | null {
  switch (LIMIT_UNITS[limit]) {
    case LimitUnit.Megabytes:
      return value * MB;
    case LimitUnit.Gigabytes:
      return value * 1024 * MB;
    case LimitUnit.Count:
      return null;
  }
}

export interface UsageRow {
  limit: PlanLimit;
  used: number;
  max: PlanLimitValue;
  /** Доля израсходованного от 0 до 1; null — без ограничения. */
  ratio: number | null;
  /** Новое действие этого вида будет отклонено (PLAN-UC-6.CC-2, PLAN-RULE-1). */
  exhausted: boolean;
}

export function usageRows(account: AccountPlanDto): UsageRow[] {
  return account.usage.map(({ limit, used, max }) => ({
    limit,
    used,
    max,
    ratio: max === null ? null : max === 0 ? 1 : Math.min(1, used / max),
    // Объём и трафик дробные: исчерпан, когда дошли до лимита; штуки — когда следующая не влезает.
    exhausted: max !== null && used >= max,
  }));
}

/** Краткая строка лимитов плана для таблицы: только заданные, по порядку. */
export function limitedOnly(plan: Pick<PlanDto, 'limits'>): { limit: PlanLimit; max: number }[] {
  return Object.values(PlanLimit)
    .map((limit) => ({ limit, max: plan.limits[limit] }))
    .filter((item): item is { limit: PlanLimit; max: number } => item.max !== null);
}
